import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-place",
  "use": "icon-place-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-place\"><defs><style type=\"text/css\"></style></defs><path d=\"M513.13664 22.17642667c-224.78734222 0-407.01610667 182.22762667-407.01610667 407.01610666 0 112.63089778 45.75118222 214.57464889 119.68056889 288.26624l-0.78961777 0.78961778L512 1005.23690667l274.39331555-274.39217778c82.15665778-74.46755555 133.76056889-182.03192889 133.7605689-301.65105778 0-224.78961778-182.22876445-407.01724445-407.01724445-407.01724444zM512 584.19086222c-84.97493333 0-153.86055111-68.88675555-153.86055111-153.86055111S427.02392889 276.47089778 512 276.47089778c84.97379555 0 153.86055111 68.88561778 153.86055111 153.86055111S596.97379555 584.19086222 512 584.19086222z\" p-id=\"10167\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/place.svg
// module id = i+qC
// module chunks = 6